import { Component, h } from "@lukekaalim/act"
import { html, PropsFromClass } from "@lukekaalim/act-web"

import classes from './index.module.css';
import { assetURLs } from "../../assets";

export type ProfileCapsuleButtonProps = {
  icon?: keyof typeof assetURLs.icons
} & PropsFromClass<HTMLButtonElement>;

export const ProfileCapsuleButton: Component<ProfileCapsuleButtonProps> = ({ children, icon = null, ...props }) => {
  return h(html.button, { className: classes.capsuleButton,  ...props }, [
    icon && h(html.img, { src: assetURLs.icons[icon], className: classes.capsuleButtonIcon })
  ])
}